import { wallClockSleep } from "../boot/utils/wallClockSleep";
import type { GameHistoryProvider } from "../game-history/GameHistoryProvider";
import type { GameHistoryData, GameHistoryEntry } from "../game-history/GameHistoryTypes";

/**
 * The offline history a title runs on without a backend, over the title's rows: the first `pageSize` bet rows, then
 * the rows after `beforeRoundId`, at most `pageSize` per call (the port's contract); the two leaderboards whole, on the
 * first page only. Each answer is a fresh array, because the history presenter appends a later page to the one it
 * was given. Until decision 40 each title wrote its own, which answered every row at once and `[]` to every load-more.
 */
export class FixtureGameHistoryProvider implements GameHistoryProvider {
  private readonly data: GameHistoryData;
  private readonly simulatedLatencyMs: number;

  public constructor(data: GameHistoryData, options: { simulatedLatencyMs?: number } = {}) {
    this.data = data;
    this.simulatedLatencyMs = options.simulatedLatencyMs ?? 0;
  }

  public async fetchInitialPage(input: { pageSize: number }): Promise<GameHistoryData> {
    await wallClockSleep(this.simulatedLatencyMs);
    return {
      betHistory: this.data.betHistory.slice(0, input.pageSize),
      biggestWinsAllGames: this.data.biggestWinsAllGames,
      biggestWinsCurrentGame: this.data.biggestWinsCurrentGame,
    };
  }

  public async fetchMoreBetHistory(input: { beforeRoundId: string; pageSize: number }): Promise<GameHistoryEntry[]> {
    await wallClockSleep(this.simulatedLatencyMs);
    const cursor = this.data.betHistory.findIndex((entry) => entry.roundId === input.beforeRoundId);
    return cursor < 0 ? [] : this.data.betHistory.slice(cursor + 1, cursor + 1 + input.pageSize);
  }
}
